module.exports = __webpack_public_path__ + "static/media/01-galeria-03-cartier-mobile@2x.95f48773.jpg";